import React from 'react';
import { useDispatch } from 'umi';
import { Button, Divider, Flex } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import BookingPagesList from '@/components/BookingPage/BookingPageList';
import { AssigneeModel } from '@/typings/models/Assignee';
import { BookingPageModel } from '@/typings/models/BookingPage';
import { F, INTL_ACTION, INTL_ENTITY } from '@/utils/intl';
import { CheckAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import { useDefaultLeadSourceConfiguration } from '@/utils/hooks';

interface AgentBookingLinksTabProps {
  agent: AssigneeModel;
}

const AgentBookingLinksTab: React.FC<AgentBookingLinksTabProps> = ({
                                                                     agent,
                                                                     toggleDrawer,
                                                                   }) => {
  const dispatch = useDispatch();
  const defaultLeadSourceConfiguration = useDefaultLeadSourceConfiguration();

  const onRefresh = () => {
    dispatch({
      type: 'user/fetchSingleAgent',
      payload: {
        agentId: agent.id,
      },
    });
  };

  const openCreateDrawer = () => {
    dispatch({
      type: 'bookingPages/toggleDrawer',
      payload: {
        mode: 'create',
        userId: agent.id,
        onRefresh,
        closeParentDrawer: true,
      },
    });
  };

  const openEditDrawer = (bookingPage: BookingPageModel) => {
    dispatch({
      type: 'bookingPages/toggleDrawer',
      payload: {
        mode: 'edit',
        bookingPage,
        userId: agent.id,
        onRefresh,
        closeParentDrawer: true,
      },
    });
  };

  return (
    <div style={{ padding: '0 24px' }}>
      <Flex justify={'end'} style={{ marginBottom: 16 }}>
        {defaultLeadSourceConfiguration?.base_url && (
          <CheckAccess
            access={[
              PERMISSIONS.BOOKING_PAGES.MANAGE,
              PERMISSIONS.BUSINESS_PARTNER,
            ]}
          >
            <Button
              type={'primary'}
              icon={<PlusOutlined />}
              onClick={openCreateDrawer}
            >
              <F entity={INTL_ENTITY.BOOKING_PAGE} action={INTL_ACTION.NEW} />
            </Button>
          </CheckAccess>
        )}
      </Flex>
      <Divider style={{ margin: '16px 0' }} />
      <BookingPagesList
        onEdit={openEditDrawer}
        onRefresh={onRefresh}
        onContactSupport={toggleDrawer}
        list={agent.booking_links || []}
        userId={agent.id!}
      />
    </div>
  );
};

export default AgentBookingLinksTab;
